import { cn, ConditionalRender, Inline, Skeleton, Stack } from '@crossnokaye/ux-common';

import { IconConfig, IconConfigVariant } from '@repo/sdk/models/components';

import { AnimaticIcon } from '@/features/equipment-browser/animatics/animatic-icon';

type ShelfIconSectionProps = {
  icon: IconConfig;
  isMobile: boolean;
};

const ShelfIconSection = ({ icon, isMobile }: ShelfIconSectionProps) => {
  const iconVariant = icon.variant ?? IconConfigVariant.Default;
  const label = icon.label;
  return (
    <Stack className={'flex-1 items-center p-2 @2xl:p-1'} gap="thin">
      <AnimaticIcon icon={icon.icon} variant={iconVariant} size={isMobile ? 'sm' : 'md'} />
      <ConditionalRender condition={!!label}>
        <span className={cn('text-base font-bold leading-5 @2xl:text-sm')}>{label}</span>
      </ConditionalRender>
    </Stack>
  );
};

type AnimaticShelfIconsProps = {
  icons: IconConfig[];
  isMobile: boolean;
};

export const AnimaticShelfIcons = ({
  icons,
  isMobile,
}: AnimaticShelfIconsProps): React.ReactNode => {
  return (
    <Inline
      className="rounded-md border-2 border-tertiary divide-x-2 divide-tertiary text-white"
      gap="sm"
      wrap={false}
    >
      {icons.map((icon, index) => (
        <ShelfIconSection key={`${icon.icon}-${index}`} icon={icon} isMobile={isMobile} />
      ))}
    </Inline>
  );
};

export const IconShelfSkeletons = () => {
  return (
    <Stack className="w-full" gap="sm">
      <Skeleton className="w-40 h-4" />
      <Skeleton className="w-full h-10" />
    </Stack>
  );
};
